import * as Sentry from '@sentry/react'

export const initSentry = () => {
  return Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    enabled: import.meta.env.VITE_DEV !== 'true',
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    integrations: [],
    release: `${import.meta.env.VITE_SENTRY_APP_NAME}@${import.meta.env.VITE_SENTRY_APP_VERSION}`,
    sendDefaultPii: false,
    tracesSampleRate: 0.2,
  })
}
